import React from 'react';
import { searchFreeText } from './services/apiService';
import { getFilterInfo } from './ConversationalSearch';

export function createFilterSearchContext(value) {
  return {
    query: value.trim(),
  };
}

export async function performFilterSearch(config, requestConfig, fromPos, searchContext) {
  const data = await searchFreeText(config, requestConfig, fromPos, searchContext);
  const filtersUsed = data?.filters_used || data?.output?.filters_used || data?.output?.filters || null;

  return {
    data: data?.output?.documents || [],
    originalQuery: data?.output?.original_query || searchContext?.query,
    usedQuery: data?.output?.query || searchContext?.query,
    accordionInfo: getFilterInfo(filtersUsed) || null,
  };
}

export default function FilterSearch() {
  return null;
}
